import ConfirmationDialog from "components/common/ConfirmationDialog";

interface Props {
  onClose: () => void;
  handleConfirm: ()=> void
}

export default function CreateStripeCustomerConfirmationDialog(props: Props) {
  const { onClose, handleConfirm } = props;

  const content = "Do you want to create a stripe customer id for this user?";

  return (
    <>
      <ConfirmationDialog
          title="Create stripe customer"
          onConfirm={handleConfirm}
          onCancel={onClose}
          content={content}
        />
    </>
  );
}

